import {FeedbackState} from '../_reducers/feedback';

type LocalState = {
    feedback: FeedbackState;
};

export const getFeedbackModalIsShowing = ({ feedback }: LocalState): boolean => {
    return feedback.isShowingModal;
};